import { Formik } from 'formik';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { getSelectedCountry } from '../../../../states/slices/resourceSlice';
import { createBranch } from '../../../../api/requests';
import Input from '../../../../components/form-control/Input';
import Button from '../../../../components/form-control/Button';
import { showToast } from '../../../../utils/miscFunctions';


interface IBranchProps {
  onClose: () => void;
  onProceed: () => void;
}

interface IBranch {
  active: boolean;
  address: string;
  email: string;
  name: string;
  phone: string;
}

const CreateNewBranch = (props: IBranchProps): JSX.Element => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const selectedCountry = useSelector(getSelectedCountry);



  return (
    <div className="py-6 px-3 md:px-6  w-full">
      <Formik
        initialValues={{
          active: true,
          address: '',
          email: '',
          name: '',
          phone: ''
        }}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={Yup.object().shape({
          address: Yup.string().trim().required('Address is required.'),
          email: Yup.string().trim().required('Email is required.'),
          name: Yup.string().trim().required('Name is required.'),
          phone: Yup.string().trim().required('Phone is required.'),
        })}

        onSubmit={async (values: IBranch, { resetForm }) => {
          const payload: IBranch = {
            active: true,
            address: values.address,
            email: values.email,
            name: values.name,
            phone: values.phone,
          };

          await createBranch(payload)
            .then((response: any) => {
              showToast.success(response?.message ?? "Branch created successfully")
            })
            .catch((error: any) => {
              console.log(error?.description);
            })
            .finally(() => {
              resetForm();
              props.onProceed();
            });
        }}>
        {({
          values,
          errors,
          isSubmitting,
          handleSubmit,
          handleChange,
          handleBlur,
          setFieldValue,
          touched
        }) => (
          <form className="" onSubmit={handleSubmit}>
            <div className="w-full flex flex-col space-y-8">
              <Input
                type={'text'}
                name="address"
                value={values.address}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Address"
                placeholder="Enter address"
                required
                error={touched.address ? errors.address : undefined}
                helperText={touched?.address ? errors.address : undefined}
                className="rounded"
              />

              <Input
                type={'text'}
                name="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Branch Email"
                placeholder="Enter branch email"
                required
                error={touched.email ? errors.email : undefined}
                helperText={touched?.email ? errors.email : undefined}
                className="rounded"
              />

              <Input
                type={'text'}
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Branch Name"
                placeholder="Enter branch name"
                required
                error={touched.name ? errors.name : undefined}
                helperText={touched?.name ? errors.name : undefined}
                className="rounded"
              />

              <Input
                type={'text'}
                name="phone"
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Phone Number"
                placeholder="Enter phone number"
                required
                error={touched.phone ? errors.phone : undefined}
                helperText={touched?.phone ? errors.phone : undefined}
                className="rounded"
              />

              <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={props.onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  label="Create Branch"
                  onClick={handleSubmit}
                  bgColor='primary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default CreateNewBranch;
